import { render, staticRenderFns } from "./activeTag.vue?vue&type=template&id=59c03966&scoped=true"
import script from "./activeTag.vue?vue&type=script&lang=js"
export * from "./activeTag.vue?vue&type=script&lang=js"
import style0 from "./activeTag.vue?vue&type=style&index=0&id=59c03966&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c03966",
  null
  
)

export default component.exports